import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import tableToExcel from '../../excel-downloads/tableToExcel';

const handleDownload = () => {
    tableToExcel('SucessReport', 'My Worksheet');
};

const fetchTransactionData = async (params) => {
    const response = await fetch(`${process.env.REACT_APP_URL_HEADER}/uidai/Auth_Fail_Int`, {

        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch transaction data');
    }
    const data1 = await response.json();
    return data1;
};

const DetailedTransaction = ({ month, year }) => {
    const [data, setdataList] = useState([]);
    const [errorCodeList, seterrorCodeList] = useState([]); // State for error list
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const detailsRef = useRef(null);

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            const params = {
                month: month,
                year: year,
            };

            try {
                const response_data = await fetchTransactionData(params);
                setTabHeading(response_data.heading);

                if (response_data && response_data.data) {
                    setdataList(response_data.data);

                    const codes = response_data.data.reduce((acc, item) => {
                        item.errorCodeList?.forEach(failure => {
                            if (!acc.some(existing => existing.response_code === failure.response_code)) {
                                acc.push(failure);
                            }
                        });
                        return acc;
                    }, []);

                    seterrorCodeList(codes);
                } else {
                    setdataList([]);
                }

            } catch (error) {
                console.error(error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year]);

    useEffect(() => {
        if (!loading && !error && data.length > 0 && detailsRef.current) {
            detailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, error, data]);

    const commodityTotals = Array(errorCodeList.length).fill(0);
    // let totalAvailableCards = 0;
    let failureCards = 0;

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal Error</div>;
    }

    if (data.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }

    return (
        <>

<div align="right"><a
				href={"https://epos.jk.gov.in/Auth_Fail.jsp?month="+month+"&year="+ year +"&exportToExcel=YES"}
				style={{fontSize: '15px', fontWeight: 'bold', color: 'blue'}}>FPS Wise Excel Download</a></div> 
            <br></br>
            <table align="center" width="90%" border={1} id="SucessReport">
                <thead>
                    <tr className="tableheader">
                      
                        <th colSpan={(errorCodeList.length) + 3}>
                            {tabHeading.substring(0, 51)}
                            <span style={{ color: 'orange' }}>{tabHeading.substring(51, 70)}</span>

                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>District</th>
                    </tr>
                    <tr className="tableheader">
                        {errorCodeList.map((item, index) => (
                            <th key={index}>{item.response_code}</th>
                        ))}
                        <th bgcolor="#ff9900">Total</th>
                    </tr>

                </thead>
                <tbody>
                    {data.map((item, index) => {
                        failureCards += parseInt(item.dist_name, 10) || 0;

                        return (
                            <tr key={`${item.dist_name}-${index}`}>
                                <td style={{ textAlign: 'center' }}>
                                    {index+1} 
                                </td>
                                <td style={{ textAlign: 'left' }}>
                                    {item.dist_name}  
                                </td>

                                {errorCodeList.map((code, i) => {
                                    const val = item.errorCodeList?.find(c => c.response_code === code.response_code)?.failure || 0;
                                    commodityTotals[i] += parseFloat(val, 10);
                                    return (
                                        <td key={i} style={{ textAlign: 'center' }}>
                                            {val}
                                        </td>

                                    );
                                })}

                                <td style={{ textAlign: 'center' }}>
                                    {errorCodeList.reduce((sum, code) => {
                                        const val = parseFloat(
                                            item.errorCodeList?.find(c => c.response_code === code.response_code)?.failure || 0
                                        );
                                        return sum + val;
                                    }, 0)}
                                </td>


                            </tr>
                        );
                    })}
                    <tr className="tableheader">
                        <td colSpan={2} style={{ textAlign: 'center' }}>Total</td>

                        {commodityTotals.map((total, i) => (
                            <td key={i} style={{ textAlign: 'center' }}>{total}</td>
                        ))}

                        <td style={{ textAlign: 'center' }}>
                            {data.reduce((sum, item) => {
                                const rowTotal = errorCodeList.reduce((rowSum, code) => {
                                    const val = parseFloat(
                                        item.errorCodeList?.find(c => c.response_code === code.response_code)?.failure || 0
                                    );
                                    return rowSum + val;
                                }, 0);
                                return sum + rowTotal;
                            }, 0)}
                        </td>
                    </tr>
                </tbody>

                <tr>
                    <td colSpan={errorCodeList.length + 3} style={{ textAlign: 'right' }}>
                        Data Refresh Time: {data[0]?.data_time.substring(0, 19) || 'No data available'}
                    </td>
                </tr>
            </table>
            <br></br>
            <br></br>
        </>
    );
};

export default DetailedTransaction;





